import initializeForm from './initializeForm';

export default (item, successCallback) => (dispatch) => {
    dispatch(initializeForm(item));
    if (successCallback) successCallback();
};
